import React, { Component } from 'react';
import CommToolContext from '../../common/comm_tool_context';
import { Grid, Row, Col } from 'react-flexbox-grid';
import {
  getIpsTeamRoleMembers,
  getAllDropDownOptions,
  getFMPProject
} from '../../../api';
import FMTrackersTabs from './fmptra_tabs';
import Spinner, { spinnerOff, spinnerOn } from 'components/Spinner';

class FMPTrackersTabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
     
      projectInfo: {
        bpid: props.match.params.bpid,
          workOrder: props.match.params.workOrder,
        stationName:decodeURIComponent(props.match.params.station_name),
        fmpId: props.match.params.fmpId
        
      },
      // props.match.params.projectId
    };
  }

  async componentDidMount() {
    spinnerOn()
    const getProject = getFMPProject(this.state.projectInfo);
    const getTeamMembers = getIpsTeamRoleMembers(this.state.projectInfo);
    
    const getAllDropdownOptions = getAllDropDownOptions();

    const result = await Promise.allSettled([
      getProject,
      getTeamMembers,
      
      getAllDropdownOptions
    ]);
spinnerOff()
    const project = result[0].value;
    const teamMembers = result[1].value;
    const allDropDownOptions = result[2].value

    this.setState({
      project: project,
      teamMembers: teamMembers,
      
      allDropDownOptions:allDropDownOptions
    });
  }
  getProjectTabStatus(){
    if (this.props.history.location) {
      let pathname = this.props.history.location.pathname;
      if (pathname) {
        if (pathname.includes("fmptracker_progress")) {
          return "fmptracker_progress";
        } else if (pathname.includes("fmptracker_complete")) {
          return "fmptracker_complete";
        } else if (pathname.includes("fmptracker_review")) {
          return "fmptracker_review";
         } else if (pathname.includes("fmptracker_asbuilts")) {
          return "fmptracker_asbuilts";
        } else {
          return null;
        }

      }
    }

}

  render() {
    const { project, teamMembers,allDropDownOptions } = this.state;
    let status = this.getProjectTabStatus();
    
    return (
      <CommToolContext.Consumer>
        {(context) => (
          <React.Fragment>
            <Grid fluid>
              <Row>
                <Col xs>
                  <Col className='pt-4' >
                <Spinner/>
                </Col>
                  {project && (
                    <FMTrackersTabs
                      project={project}
                      teamMembersList={teamMembers}
                      allDropDownOptions={allDropDownOptions}
                      context={context}
                      status={status}
                    />
                  )}
                </Col>
              </Row>
            </Grid>
          </React.Fragment>
        )}
      </CommToolContext.Consumer>
    );
  }
}

FMPTrackersTabs.contextType = CommToolContext;
export default FMPTrackersTabs;
